import React, { useEffect, useState } from "react";
import DateRange from "../DateRange/DateRange";
import { dashboardIcon } from "../../assets/img";
import { URLS } from "../../Services/Constant";
import { get } from "../../Services/ApiHandler";
import { useGlobalContext } from "../../Services/PaginationGlobal";
import { useLocation } from "react-router-dom";

export const MMC = () => {
  const styles = {
    label: {
      fontFamily: "Open Sans",
      fontStyle: "normal",
      fontWeight: "600",
      fontSize: "14px", // smaller
      lineHeight: "20px",
      color: "#A7A7A7",
    },
    value: {
      fontFamily: "Open Sans",
      fontStyle: "normal",
      fontWeight: "600",
      fontSize: "16px", // smaller
      lineHeight: "22px",
      color: "#222227",
    },
  };

  const [isData, setIsData] = useState({});
  const { paginationData } = useGlobalContext();
  const { pathname } = useLocation();
  const path = pathname?.replace("/", "");
  const [selectedFilter, setSelectedFilter] = useState(
    paginationData?.[path]
      ? { ...paginationData?.[path] }
      : { from: "", to: "" }
  );

  const getTopCard = async () => {
    let url = URLS.DASHBOARMMC_CARD;
    const params = [];

    if (selectedFilter.from && selectedFilter.to) {
      params.push(`from_date=${selectedFilter.from}`);
      params.push(`to_date=${selectedFilter.to}`);
    }

    if (params.length > 0) {
      url += `?${params.join("&")}`;
    }

    try {
      let res = await get(url);
      if (res?.status === "success") {
        setIsData(res?.data ?? {});
      }
    } catch (error) {
      console.error("Error fetching revenue data:", error);
    }
  };

  useEffect(() => {
    getTopCard();
  }, [selectedFilter.from, selectedFilter.to]);

  const handleChangeFilter = (name, val) => {
    setSelectedFilter((prev) => ({ ...prev, [name]: val }));
  };

  return (
    <div
      style={{
        padding: 14, // smaller
        width: "100%",
        background: "#FFFFFF",
        boxShadow: "0px 1px 8px rgba(0, 0, 0, 0.1)", // lighter
        borderRadius: "8px", // smaller
        height: "100%",
      }}
    >
      {/* Header */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 12, // smaller
        }}
      >
        <p
          style={{
            fontStyle: "normal",
            fontWeight: "700",
            fontSize: "15px", // smaller
            lineHeight: "20px",
            display: "flex",
            alignItems: "center",
            width: "80px",
            color: "#222227",
            margin: 0,
          }}
        >
          MMC
        </p>
        <div className="d-flex ac-jb mt-2 gap-1 flex-wrap">
          <DateRange
            setFromDate={(date) => handleChangeFilter("from", date)}
            setToDate={(date) => handleChangeFilter("to", date)}
          />
        </div>
      </div>

      {/* Total Properties Count */}
      <div
        style={{
          border: "1px solid #EEEEEE",
          display: "flex",
          justifyContent: "space-between",
          borderRadius: "16px", // smaller
          padding: "14px 20px", // smaller
          marginTop: "14px", // smaller
        }}
      >
        <div>
          <p
            style={{
              fontSize: "16px", // smaller
              fontWeight: "400",
              color: "#9ca3af",
              margin: 0,
              display: "flex",
              alignItems: "center",
              gap: "6px", // smaller
            }}
          >
            Total Properties Count
          </p>
          <p
            style={{
              fontSize: "22px", // smaller
              fontWeight: "bold",
              color: "#000000",
              margin: 0,
            }}
          >
            {isData?.total_properties_count &&
              (isData?.total_properties_count || 0).toFixed(2)}
          </p>
        </div>
        <div style={{ width: "26px", height: "26px" }}>
          <img
            src={dashboardIcon}
            alt=""
            style={{ width: "100%", height: "100%" }}
          />
        </div>
      </div>

      {/* Total Section */}
      <p
        style={{
          marginTop: "8px",
          fontFamily: "Open Sans",
          fontStyle: "normal",
          fontWeight: "700",
          fontSize: "15px", // smaller
          lineHeight: "20px",
          color: "#222227",
        }}
      >
        Total
      </p>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 4,
          marginTop: "8px",
        }}
      >
        {[
          {
            label: "MMC Active Properties",
            value: isData?.mmc_active_properties,
          },
          {
            label: "MMC Suspended Properties",
            value: isData?.mmc_suspended_properties,
          },
          {
            label: "MMC Cancelled Properties",
            value: isData?.mmc_cancelled_properties,
          },
        ].map((item, index) => (
          <div
            key={index}
            style={{
              background: "#F5F5F5",
              display: "flex",
              justifyContent: "space-between",
              padding: "8px 10px", // smaller
              width: "100%",
              borderRadius: "8px", // smaller
              marginBottom: "8px", // smaller
            }}
          >
            <p style={styles.label}>{item.label}</p>
            <p style={styles.value}>{(item.value || 0).toFixed(2)}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
